module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag06_0256AT.ffedf860.jpg";